module.exports = __webpack_public_path__ + "img/htp-slide-three.e0152065.png";